export const FRONT_URL = process.env.REACT_APP_FRONT_URL;
export const BASE_URL = process.env.REACT_APP_API_URL;
export const API_VERSION = process.env.REACT_APP_API_VERSION;
export const CENTRIFUGE_URI = process.env.REACT_APP_CENTRIFUGE_URI;
export const APP_VERSION = process.env.REACT_APP_VERSION;
export const KEYCLOAK_HOST =
  process.env.REACT_APP_KEYCLOAK_HOST || 'https://auth.intexsoft.com';
export const KEYCLOAK_REALM =
  process.env.REACT_APP_KEYCLOAK_REALM || 'intexsoft';
export const KEYCLOAK_CLIENT =
  process.env.REACT_APP_KEYCLOAK_CLIENT || 'hunter';
export const KEYCLOAK_CHECK_LOGIN_IFRAME =
  process.env.REACT_APP_KEYCLOAK_CHECK_LOGIN_IFRAME || 'false';
export const LINKEDIN_EXTENSION_REDIRECT_URI =
  process.env.REACT_APP_LINKEDIN_EXTENSION_REDIRECT_URI ||
  'https://www.linkedin.com';
